// A mirror of the active locale for non-React modules (timeFmt, age) that
// format strings outside the component tree and can't call useT(). The
// LocaleProvider keeps this in sync whenever the locale changes.

import type { Locale } from "./index";

let current: Locale = "en";

export function setRuntimeLocale(l: Locale): void {
  current = l;
}

export function runtimeLocale(): Locale {
  return current;
}
